import { getByDisplayValue } from '@testing-library/dom';
import React, { useEffect, useState } from 'react';
import { VersionGias } from '../../../../../infraestructure/persistence/rest/VersionesGiasAdapter';
import SelectorSimple from '../../../../../shared/Components/Selectores/Simple';


export const SelectorVersionesGias = (props:any) =>{
  
  let {data, onChange, idVersion} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    if(data)
    {setOptions(getOptions())}
  },[data])

  useEffect(()=>{
    if(options && options.length>0){
      idVersion ? change(idVersion) : change(options[0].value)
    }
  },[options, idVersion])
  
  const getOptions = () =>{
    return data.map((vg: VersionGias)=> { return { value: vg.idVersion, inputDisplay: vg.descCorta } })
  }

  const change = (value:any) =>{
    onChange(value)
  }

  return (
    <SelectorSimple {...props} options={options} onChange={change} name="selectVersionesGias"/>
  )
}
export default SelectorVersionesGias